import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  dialogClose: {
    marginLeft: 'auto',
    padding: theme.spacing(3),
    paddingTop: 19,
  },
  selectionBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 350,
    },
  },
  selectionHeader: {
    marginBottom: theme.spacing(4),
  },
  button: {
    width: '100%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      width: 200,
    },
  },
  header: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    left: 10,
    position: 'absolute',
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/BuyerRegistration/useStyles.js